/* eslint-disable no-console */
import { handleError } from './utils';

export const fetchData = async (
  setIsLoading,
  setError,
  request,
  data,
  callback
) => {
  console.log("--request-1-")
  setIsLoading(true);
  setError({});
  console.log('Loading started-2');
  try {
    // await request(data);
    const response = await request(data);
    console.log('Request completed-3');
    if (callback) {
      console.log('Calling callback-4');
      callback(); // await callback();
    }

    console.log("--RESP--", response)
    return response; // To return the status message
  } catch (error) {
    console.log("--error--", error)
    handleError(
      error.response?.status,
      error.response?.statusText,
      error.response?.data.message,
      setError
    );
  } finally {
    setIsLoading(false);
    console.log('Loading finished-5');
  }
};
